import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

interface PrivateRouteProps {
  children?: React.ReactElement;
  element?: React.ReactElement;
  allowedRoles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, element, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner fullPage />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access if allowedRoles is specified
  // super_admin always gets access to admin-restricted routes
  if (allowedRoles && allowedRoles.length > 0) {
    const hasAccess = allowedRoles.includes(user.profileType) ||
      (user.profileType === 'super_admin' && allowedRoles.includes('admin'));
    if (!hasAccess) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return element || children || null;
};

export default PrivateRoute;

